// extracted by mini-css-extract-plugin
export default {"faqs":"faqs_faqs__HJUn9","accordion":"faqs_accordion__4SNpq","anchor":"faqs_anchor__0gjZO"};